import styled from "styled-components";

export const Container = styled("div")`
  display: grid;
  padding-bottom: 25px;

  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
`;

export const UploadArea = styled("div")`
  border: 2px dashed #ccc;
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .file-input {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
  }

  .upload-text {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #333;
  }

  .upload-text svg {
    margin-right: 8px;
  }

  .error-message {
    color: red;
    margin-top: 10px;
  }
`;

export const ContainerFaturas = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: space-around;
`;

export const Fatura = styled.div`
  position: relative;
  padding: 10px;
  border: 1px solid rgb(217, 217, 217);
  max-width: 180px;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Content = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 25px;
`;

export const DeleteIcon = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
`;

export const Close = styled("div")`
  cursor: pointer;

  &:hover > img {
    filter: invert(100%);
    transition: filter 0.5s;
  }
`;

export const Logo = styled("div")`
  display: table;
  margin: 0 auto;
`;

export const Title = styled("div")`
  text-align: center;
  color: #ffffff;
`;

export const TitleBlack = styled("div")`
  font-size: 24px;
  font-weight: 700;
  line-height: 31.92px;
  text-align: left;
`;

export const TitleBlackUpload = styled("div")`
  font-size: 24px;
  font-weight: 700;
  line-height: 31.92px;
  text-align: center;
  margin-left: 35px;
`;

export const SubTitle = styled("div")`
  font-size: 16px;
  font-weight: 400;
  line-height: 21.79px;
  text-align: left;
`;

export const SubTitleLogin = styled("div")`
  font-size: 16px;
  font-weight: 400;
  line-height: 21.79px;
  text-align: justify;
`;

export const SubTitleUpload = styled("div")`
  font-size: 12px;
  font-weight: 400;
  line-height: 21.79px;
  text-align: left;
  color: #9e9e9e;
`;

export const Circle = styled("div")`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  cursor: pointer;
  transition: 0.5s;
  box-shadow: 0px 4px 4px 0px #00000040;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
  }

  &:hover > img {
    filter: invert(100%);
    transition: filter 0.5s;
  }
`;
export const Button = styled("button")`
  text-align: center;
  color: #000000;
  font-size: 14px;
  border-radius: 8px;
  width: 100%;
  max-width: 300px;
  height: 30px;
  outline: none;
  border: none;
  margin: 0 auto;
  cursor: pointer;

  &:hover {
    background-color: rgba(0, 0, 0, 0.1);
    color: #ffffff;
  }
`;

export const ButtonContainer = styled("div")`
  display: grid;
  padding: 20px 20px 50px 20px;
  gap: 20px;
  height: 400px;
  overflow: auto;
`;

export const ButtonContainerTop = styled.div`
  display: flex;
  justify-content: center;
`;

interface ButtonProps {
  selected: boolean;
}

export const ButtonForm = styled.button<ButtonProps>`
  margin: 0 10px;
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  background-color: ${(props) => (props.selected ? "#59981A" : "transparent")};
  color: ${(props) => (props.selected ? "#ffffff" : "#59981A")};

  cursor: pointer;
  border: 1px solid #789b60;
  border-radius: 8px;
  transition: 0.5s;

  &:hover {
    background-color: ${(props) =>
      props.selected ? "transparent" : "#59981A"};
    color: ${(props) => (props.selected ? "#59981A" : "#ffffff")};
  }
`;

export const ButtonDelete = styled.button`
  margin: 0 10px;
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  background-color: transparent;
  color: #6c5af4;

  cursor: pointer;
  border: 1px solid #6c5af4;
  border-radius: 8px;
  transition: 0.5s;
`;

export const ButtonOK = styled.button`
  margin: 0 10px;
  padding: 8px 16px;
  font-size: 14px;
  border: none;
  background-color: #6c5af4;
  color: #ffffff;

  cursor: pointer;
  border: 1px solid #6c5af4;
  border-radius: 8px;
  transition: 0.5s;
`;
export const ButtonOKUpload = styled.button`
  margin: 0px 10px;
  padding: 13px 35px;
  font-size: 16px;
  background-color: rgb(108, 90, 244);
  color: rgb(255, 255, 255);
  cursor: pointer;
  border: 1px solid rgb(108, 90, 244);
  border-radius: 8px;
  transition: all 0.5s ease 0s;
  &:disabled {
    background-color: grey;
    border: 1px solid grey;
    cursor: auto;
  }
`;

export const GridTitle = styled("div")`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

export const Grid = styled("div")`
  display: grid;
  grid-template-columns: auto auto;
  gap: 8px;
  @media (max-width: 700px) {
    grid-template-columns: auto auto;
  }
`;
